import React from 'react';

const AssessmentsHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Assessments
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The Assessments page allows you to run and view AWS Well-Architected
          Framework assessments. These assessments help identify areas for
          improvement in your cloud infrastructure.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          What is a Well-Architected Assessment?
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          AWS Well-Architected assessments evaluate your workloads against best
          practices across six pillars:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Operational Excellence:</strong> Operations as code, frequent changes</li>
          <li><strong>Security:</strong> Protecting information and systems</li>
          <li><strong>Reliability:</strong> Workload performs correctly and consistently</li>
          <li><strong>Performance Efficiency:</strong> Using resources efficiently</li>
          <li><strong>Cost Optimization:</strong> Avoiding unnecessary costs</li>
          <li><strong>Sustainability:</strong> Environmental impact minimization</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Running an Assessment
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          To run a new assessment:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li>Click "New Assessment" button</li>
          <li>Select the workload or project to assess</li>
          <li>Choose which pillars to evaluate</li>
          <li>Answer the assessment questions</li>
          <li>Review and save your results</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Assessment Results
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          View completed assessment results:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Score:</strong> Overall and per-pillar scores</li>
          <li><strong>High Risk Issues:</strong> Critical items needing attention</li>
          <li><strong>Medium Risk Issues:</strong> Important improvements to consider</li>
          <li><strong>Recommendations:</strong> Actionable steps to improve</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Generating Reports
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Export assessment results as PDF reports to share with stakeholders.
          Reports include scores, identified risks, and recommendations for
          each pillar evaluated.
        </p>
      </div>

    </>
  );
};

export default AssessmentsHelp;
